import React from 'react';

import { twMerge } from 'tailwind-merge';

import { TbX } from 'react-icons/tb';

import Typography from 'components-new/typography/typography';
import IconButton from 'components-new/icon-button/icon-button';

interface ChipProps {
  id?: string;
  className?: string;
  buttonClassname?: string;
  typographyClassName?: string;
  title: string;
  onClose?: (id?: string) => void;
}

const Chip: React.FC<ChipProps> = (props) => {
  const { title } = props;
  const chipClassName = twMerge(
    'bg-gray100 flex items-center gap-x-2 rounded-2xl py-1 px-2 text-gray700',
    props.className,
  );
  const buttonClassName = twMerge(
    'bg-white min-w-5 min-h-5 rounded-full cursor-pointer',
    'flex justify-center items-center ',
    props.buttonClassname,
  );

  const typographyClassName = twMerge('flex', props.typographyClassName);

  return (
    <div className={chipClassName}>
      <Typography as="p" variant="body-medium" className={typographyClassName}>
        {title}
      </Typography>

      <IconButton
        buttonClassName={buttonClassName}
        icon={TbX}
        size="small"
        onClick={() => props.onClose?.(props.id)}
      />
    </div>
  );
};
export default Chip;
